import React from 'react';
import { Platform, StatusBar, StyleSheet, View } from 'react-native';
import asyncSeries from 'async/series';

import Analytics from './tools/analytics';
import Api from './tools/api';

import Stores from './stores';

import { Router, Route, Switch } from './tools/router';
import ModalContent from './components/modal_content';

import LoadingScreen from './loading_screen';
import HomeScreen from './home_screen';
import NotFoundScreen from './not_found_screen';

const styles = StyleSheet.create({
  app: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'black',

    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
});

type Props = {};
type State = {
  is_loading: boolean;
  is_logged_in: boolean;
};

export default class App extends React.PureComponent<Props, State> {
  state = {
    is_loading: true,
  };
  _isStartupDone = false;

  componentDidMount() {
    ModalContent.reset();
    if (Platform.OS === 'android') {
      StatusBar.setBackgroundColor('transparent');
    }
    StatusBar.setBarStyle('dark-content');
    _startup(() => {
      this._isStartupDone = true;
      this._maybeLoadingDone();
    });
  }

  _maybeLoadingDone = () => {
    if (this._isStartupDone) {
      this.setState({ is_loading: false });
    }
  };

  render() {
    const { is_loading } = this.state;

    let content = null;
    if (is_loading) {
      content = <LoadingScreen />;
    } else {
      content = (
        <Router>
          <Switch>
            <Route exact path='/' component={HomeScreen} />
            <Route exact path='/buy' component={HomeScreen} />
            <Route exact path='/sell' component={HomeScreen} />
            <Route exact path='/order' component={HomeScreen} />
            <Route path='*' component={NotFoundScreen} />
          </Switch>
          <ModalContent key='modal' />
        </Router>
      );
    }
    return <View style={styles.app}>{content}</View>;
  }
}

function _startup(done) {
  asyncSeries([Analytics.init, Api.init, Stores.init], () => {
    Analytics.loadFinish();
    done();
  });
}
